import { render, staticRenderFns } from "./ReportSalesPerProductPage.vue?vue&type=template&id=08d828f8&scoped=true"
import script from "./ReportSalesPerProductPage.vue?vue&type=script&lang=js"
export * from "./ReportSalesPerProductPage.vue?vue&type=script&lang=js"
import style0 from "./ReportSalesPerProductPage.vue?vue&type=style&index=0&id=08d828f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d828f8",
  null
  
)

export default component.exports